export default __webpack_public_path__ + "static/pie-in-a-doughnut-822bb899f91273f6e34ec894e25cfd2d.png";